const routers = [
  {
    path: "/",
    redirect: "/auth",
  },
  {
    component: "AuthLayout",
    path: "/auth",
    auth: false,
    name: "Auth",
    exact: false,
    redirect: "/auth/login",
    childrens: [
      {
        component: "SignUp",
        path: "/sign-up",
        componentPath: "pages/Auth/SignUp",
        name: "SignUp",
        auth: false,
        exact: true,
      },
      {
        component: "Login",
        path: "/login",
        componentPath: "pages/Auth/Login",
        name: "Login",
        auth: false,
        exact: true,
      },
      {
        component: "Verify",
        path: "/verify-otp",
        componentPath: "pages/Auth/Verify",
        name: "Verify",
        auth: false,
        exact: true,
      },
      {
        component: "VerifyReset",
        path: "/verify-otp/reset",
        componentPath: "pages/Auth/VerifyReset",
        name: "VerifyReset",
        auth: false,
        exact: true,
      },
      {
        component: "Password",
        path: "/password",
        componentPath: "pages/Auth/password",
        name: "Password",
        auth: false,
        exact: true,
      },
      {
        component: "ForgotPassword",
        path: "/forgot-password",
        componentPath: "pages/Auth/ForgotPassword",
        name: "ForgotPassword",
        auth: false,
        exact: true,
      },
      {
        component: "SentOtp",
        path: "/sent-otp",
        componentPath: "pages/Auth/SentOtp",
        name: "SentOtp",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPassword",
        path: "/reset-password",
        componentPath: "pages/Auth/ResetPassword",
        name: "ResetPassword",
        auth: false,
        exact: true,
      },
      {
        component: "TermsPrivacyAndPolicy",
        path: "/terms",
        componentPath: "pages/Auth/TermsPrivacyAndPolicy",
        name: "TermsPrivacyAndPolicy",
        auth: false,
        exact: true,
      },
      {
        component: "ExpireVideoCall",
        path: "/call-info",
        componentPath: "pages/Dashboard/DashboardScreen/ExpireVideoCall",
        name: "ExpireVideoCall",
        auth: false,
        exact: true,
      },
    ],
  },

  //profile creation
  {
    component: "AuthLayout",
    path: "/profile",
    auth: false,
    name: "Profile",
    exact: false,
    redirect: "/profile",
    childrens: [
      {
        component: "BasicDetails",
        path: "/basic-details",
        componentPath: "pages/Dashboard/ProfileCreation/BasicDetails",
        name: "BasicDetails",
        auth: false,
        exact: true,
      },
      {
        component: "EducationDetails",
        path: "/education-details",
        componentPath: "pages/Dashboard/ProfileCreation/EducationDetails",
        name: "EducationDetails",
        auth: false,
        exact: true,
      },
      {
        component: "Appointment",
        path: "/appointment",
        componentPath: "pages/Dashboard/ProfileCreation/Appointment",
        name: "Appointment",
        auth: false,
        exact: true,
      },
      {
        component: "PaymentDetails",
        path: "/payment-details",
        componentPath: "pages/Dashboard/ProfileCreation/PaymentDetails",
        name: "PaymentDetails",
        auth: false,
        exact: true,
      },
      {
        component: "DetailPreview",
        path: "/details-preview",
        componentPath: "pages/Dashboard/ProfileCreation/DetailPreview",
        name: "DetailPreview",
        auth: false,
        exact: true,
      },
      {
        component: "Consent",
        path: "/consent",
        componentPath: "pages/Dashboard/ProfileCreation/Consent",
        name: "Consent",
        auth: false,
        exact: true,
      },
    ],
  },
  //view profile and edit
  {
    component: "AuthLayout",
    path: "/edit-detail",
    auth: false,
    name: "Profile",
    exact: false,
    redirect: "/edit-detail",
    childrens: [
      {
        component: "EditBasicDetails",
        path: "/basic-details",
        componentPath:
          "pages/Dashboard/ProfileCreation/EditDetails/EditBasicDetails",
        name: "EditBasicDetails",
        auth: false,
        exact: true,
      },
      {
        component: "EditAppointment",
        path: "/edit-appointment",
        componentPath:
          "pages/Dashboard/ProfileCreation/EditDetails/EditAppointment",
        name: "EditAppointment",
        auth: false,
        exact: true,
      },
      {
        component: "EditEducationDetails",
        path: "/education-details",
        componentPath:
          "pages/Dashboard/ProfileCreation/EditDetails/EditEducationDetails",
        name: "EditEducationDetails",
        auth: false,
        exact: true,
      },

      {
        component: "EditPaymentDetails",
        path: "/payment-details",
        componentPath:
          "pages/Dashboard/ProfileCreation/EditDetails/EditPaymentDetails",
        name: "EditPaymentDetails",
        auth: false,
        exact: true,
      },
    ],
  },
  //profile Edit
  {
    component: "MainLayout",
    path: "/edit",
    auth: false,
    name: "Profile",
    exact: false,
    redirect: "/profile",
    childrens: [
      {
        component: "EditProfile",
        path: "/edit-profile",
        componentPath: "pages/Dashboard/EditProfiles/EditProfile",
        name: "EditProfile",
        auth: false,
        exact: true,
      },
      {
        component: "EditEducation",
        path: "/edit-education",
        componentPath: "pages/Dashboard/EditProfiles/EditEducation",
        name: "EditEducation",
        auth: false,
        exact: true,
      },
      {
        component: "EditPayment",
        path: "/edit-payment",
        componentPath: "pages/Dashboard/EditProfiles/EditPayment",
        name: "EditPayment",
        auth: false,
        exact: true,
      },
      {
        component: "EditAppointment",
        path: "/edit-appointment",
        componentPath: "pages/Dashboard/EditProfiles/EditAppointment",
        name: "EditAppointment",
        auth: false,
        exact: true,
      },
      {
        component: "EditBio",
        path: "/edit-bio",
        componentPath: "pages/Dashboard/EditProfiles/EditBio",
        name: "EditBio",
        auth: false,
        exact: true,
      },
    ],
  },
  // DASHBOARD

  {
    component: "MainLayout",
    path: "/doctor",
    auth: false,
    name: "Dashboard",
    exact: false,
    redirect: "/doctor/dashboard",
    childrens: [
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard/InitDashboard/Dashboard",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "Appointmentlist",
        path: "/appointment-list",
        componentPath: "pages/Dashboard/AppointmentList/AppointmentList",
        name: "AppointmentList",
        auth: false,
        exact: true,
      },
      {
        component: "AppointmentlistView",
        path: "/appointment-list-view",
        componentPath: "pages/Dashboard/AppointmentList/AppointmentListView",
        name: "AppointmentListView",
        auth: false,
        exact: true,
      },
      {
        component: "VideoCallLogDetails",
        path: "/appointment-video-log/:id",
        componentPath: "pages/Dashboard/AppointmentList/VideoCallLog",
        name: "VideoCallLogDetails",
        auth: false,
        exact: true,
      },
      {
        component: "VoiceCallLogDetails",
        path: "/appointment-voice-log/:id",
        componentPath: "pages/Dashboard/AppointmentList/VoiceCallLog",
        name: "VoiceCallLogDetails",
        auth: false,
        exact: true,
      },
      {
        component: "AppointmentDetailView",
        path: "/appointment-detail-view/:id",
        componentPath: "pages/Dashboard/AppointmentList/AppointmentDetailView",
        name: "AppointmentDetailView",
        auth: false,
        exact: true,
      },
      {
        component: "PatientProfileView",
        path: "/patient-profile/:appointmentId",
        componentPath: "pages/Dashboard/PatientProfile/PatientProfileView",
        name: "PatientProfileView",
        auth: false,
        exact: true,
      },
      {
        component: "ViewConsult",
        path: "/view-consult/:id",
        componentPath: "pages/Dashboard/ViewConsult/index",
        name: "ViewConsult",
        auth: false,
        exact: true,
      },
      {
        component: "ConsultationView",
        path: "/consultation-view",
        componentPath: "pages/Dashboard/ConsultationView/ConsultationView",
        name: "ConsultationView",
        auth: false,
        exact: true,
      },
      {
        component: "PrescriptionPreview",
        path: "/prescription-preview",
        componentPath: "pages/Dashboard/ConsultationView/PrescriptionPreview",
        name: "PrescriptionPreview",
        auth: false,
        exact: true,
      },
      {
        component: "CreatePrescription",
        path: "/create-prescription/:params",
        componentPath: "pages/Dashboard/ConsultationView/CreatePrescription",
        name: "CreatePrescription",
        auth: false,
        exact: true,
      },
      {
        component: "CreatePrescription",
        path: "/create-prescription_new",
        componentPath: "pages/Dashboard/ConsultationView/CreatePrescription_new",
        name: "CreatePrescription_new",
        auth: false,
        exact: true,
      },
      {
        component: "CreatePrescription",
        path: "/prescription_preview/:params",
        componentPath: "pages/Dashboard/ConsultationView/PrescriptionPreview_new",
        name: "prescription_preview",
        auth: false,
        exact: true,
      },
      {
        component: "Availability",
        path: "/availability",
        componentPath: "pages/Dashboard/Availability/availability",
        name: "Availability",
        auth: false,
        exact: true,
      },
      {
        component: "Settings",
        path: "/settings",
        componentPath: "pages/Dashboard/Settings/Settings",
        name: "Settings",
        auth: false,
        exact: true,
      },
      {
        component: "DashboardScreen",
        path: "/dashboard-screen",
        componentPath: "pages/Dashboard/DashboardScreen",
        name: "Dashboard Screen",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/my-profile",
        componentPath: "pages/Dashboard/MyProfile/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "Support",
        path: "/support",
        componentPath: "pages/Dashboard/AppointmentList/Support",
        name: "Support",
        auth: false,
        exact: true,
      },
      {
        component: "FamilyTree",
        path: "/family-tree",
        componentPath: "pages/Dashboard/FamilyTree/FamilyTree",
        name: "FamilyTree",
        auth: true,
        exact: true,
      },
      {
        component: "FamilyMember",
        path: "/family-member/:patientId/:id?",
        componentPath: "pages/Dashboard/FamilyTree/FamilyMember/FamilyMember",
        name: "FamilyMember",
        auth: true,
        exact: true,
      },
      {
        component: "MemberTable",
        path: "/members",
        componentPath: "pages/Dashboard/FamilyTree/MemberTable",
        name: "MemberTable",
        auth: true,
        exact: true,
      },
      {
        component: "MedicalHistory",
        path: "/medical-history/:form/:patientId",
        componentPath: "pages/Dashboard/MedicalHistory/MedicalHistory",
        name: "MedicalHistory",
        auth: true,
        exact: true,
      },
      {
        component: "MedicalHistoryView",
        path: "/medical-history/view/:id",
        componentPath: "pages/Dashboard/MedicalHistoryView",
        name: "MedicalHistoryView",
        auth: true,
        exact: true,
      },
      {
        component: "FamilyMemberDetails",
        path: "/member-details/:id",
        componentPath: "pages/Dashboard/FamilyTree/FamilyMemberDetails",
        name: "FamilyMemberDetails",
        auth: true,
        exact: true,
      },
      {
        component: "FamilyConsultation",
        path: "/member-consultation-details/:famId",
        componentPath: "pages/Dashboard/FamilyConsultation",
        name: "FamilyConsultation",
        auth: true,
        exact: true,
      },
    ],
  },

  {
    component: "VideoLayout",
    path: "/consult",
    auth: false,
    name: "Dashboard",
    exact: false,
    redirect: "/consult",
    childrens: [
      {
        component: "VideoCall",
        path: "/video-consult",
        componentPath: "pages/Dashboard/DashboardScreen/VideoCall",
        name: "VideoCall",
        auth: false,
        exact: true,
      },
      {
        component: "EndVideoCall",
        path: "/end-call",
        componentPath: "pages/Dashboard/DashboardScreen/EndVideoCall",
        name: "EndVideoCall",
        auth: false,
        exact: true,
      },
    ],
  },
];
export default routers;
